exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".christmas-float[data-v-27acb129]{width:2rem;position:fixed;bottom:5.5rem;right:0;z-index:100}", "", {"version":3,"sources":["D:/BtSoft/wwwroot/h5-shop-new/src/components/home/home-float.vue"],"names":[],"mappings":"AACA,kCAAmC,WAAY,AAAC,eAAgB,AAAC,cAAe,AAAC,QAAS,AAAC,WAAa,CACvG","file":"home-float.vue","sourcesContent":["\n.christmas-float[data-v-27acb129]{ width: 2rem; position: fixed; bottom: 5.5rem; right: 0; z-index: 100;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27acb129","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/home-float.vue
// module id = J+2Z
// module chunks = 1